import React, { useEffect } from 'react';

import One from './data/one';
import Two from './data/two';
import Three from './data/three';
import './index.less';


const PageModel = props => {
	
	useEffect(() => {

	}, [ 123 ]);

	return (
		<section className="data-container">
			<div className='chart-container'>
				<One />
				<div className='chart-title'>街区店铺分布图</div>
				<Two />
				<div className='chart-title'>所有设备运行状态占比</div>
				<Three />
				<div className='chart-title'>所有设备保养占比</div>
			</div>
		</section>
	);
};

export default PageModel;
